<template>
  <b-media tag="li">
    <template v-slot:aside>
      <span class="bg-info media-wrapper">
        <span class="text-center align-middle text-white step-wrapper">{{
          index + 1
        }}</span>
      </span>
    </template>
    <h5 class="mt-0 mb-3 text-left">
      <i>{{ step.title }}</i>
    </h5>
    <p class="mb-0 text-left">
      <span style="white-space: pre-wrap; overflow-wrap: break-word">{{
        step.description
      }}</span>
    </p>
  </b-media>
</template>

<script>
export default {
  name: "RecipeStep",
  props: {
    index: Number,
    step: Object,
  },
};
</script>

<style scoped>
.media-wrapper {
  width: 64px;
  height: 64px;
}
.step-wrapper {
  font-size: xx-large;
}
</style>



// WEBPACK FOOTER //
// src/components/recipes/RecipeStep.vue